/**
 * LifetimeExplanationAlert displays a message about the rule's lifetime based on inEffectDate, expirationDate, and isActive.
 * - If isActive is false, shows that the rule is currently inactive.
 * - Otherwise, explains when the rule takes effect and/or expires, or if it is always active.
 *
 * @param form Ant Design form instance with inEffectDate, expirationDate, and isActive fields
 */
import React from 'react';
import { Alert } from 'antd';
import moment, { Moment } from 'moment';

interface LifetimeExplanationAlertProps {
  form: any;
}

const LifetimeExplanationAlert: React.FC<LifetimeExplanationAlertProps> = ({ form }) => {
  const inEffectDate: Moment | null = form.getFieldValue('inEffectDate');
  const expirationDate: Moment | null = form.getFieldValue('expirationDate');
  const isActive: boolean = form.getFieldValue('active');

  let message = '';
  let type: 'info' | 'warning' = 'info';
  if (isActive === false) {
    message = 'Rule is currently inactive.';
    type = 'warning';
  } else if (inEffectDate && expirationDate) {
    const days = expirationDate.diff(inEffectDate, 'days');
    message = `Rule will take effect ${inEffectDate.format('LL')} and will expire ${days} day${days !== 1 ? 's' : ''} later after ${expirationDate.format('LL')}.`;
  } else if (!inEffectDate && expirationDate) {
    message = `Rule will expire on ${expirationDate.format('LL')}.`;
  } else if (inEffectDate && !expirationDate) {
    message = `Rule will take effect ${inEffectDate.format('LL')} and will never expire.`;
  } else {
    message = 'Rule will always be active.';
  }
  return <Alert style={{ marginTop: 8 }} type={type} showIcon message={message} />;
};

export default LifetimeExplanationAlert;
